import { partnerStrings } from '@data/partners';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: `${partnerStrings.partner}資料`,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
  staffOnly: true,
  rolesOnly: ['admin', 'FCChina'],
};
